<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[24px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.OFFER_NAME' | translate }}
				</td>

				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'GENERAL_LABELS.DATE' | translate }}
				</td>
				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.TYPE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.AMOUNT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.BOOKINGS' | translate }}
				</td>
				<!-- <td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.CURRENT_BOOKING' | translate }}
				</td> -->
				<td
					*ngIf="offerFilter.offerActiveTab == 0"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.STATE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<!-- {{ 'OFFERS.OFFERS_LIST.ACTIONS' | translate }} -->
				</td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let offer of offers
						| paginate
							: {
									itemsPerPage: offerFilter?.paging?.pageSize,
									currentPage: offerFilter?.paging?.pageNumber,
									totalItems: totalCount
							  }
				"
				class="border-b-[1px] border-secondry-color-Gray"
			>
				<td
					[routerLink]="['view-promo-code', offer.id]"
					class="cursor-pointer text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[24px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span>
						<span class="block text-dark-grey whitespace-nowrap">
							{{
								translate.currentLang == 'en'
									? offer?.name?.en
									: offer?.name?.ar
							}}
						</span>
						<span *ngIf="!offer?.isForAllProviders" class="text-medium-gray">
							{{ offer?.offerServiceProvidersCount }}
						</span>
						<span *ngIf="offer?.isForAllProviders" class="text-medium-gray">
							{{ 'GENERAL.ALL' | translate }}
						</span>
					</span>
				</td>

				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0">
						{{ offer?.startDate | date : 'dd/MM/yyyy' }}
						{{ 'GENERAL.TO' | translate }}
						{{ offer?.endDate | date : 'dd/MM/yyyy' }}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
				>
					{{
						'OFFERS.OFFERS_LIST.' + offerType[offer.offerType].toUpperCase()
							| translate
					}}
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p *ngIf="offer?.offerMethod == 1">
						{{ offer?.percentage + '%' }}
						<span class="text-medium-gray block">
							{{ 'OFFERS.OFFERS_LIST.UP_TO' | translate }}
							{{ offer?.percentageDiscountAmountUpTo }}
							{{
								translate.currentLang == 'en'
									? offer?.currency?.name?.en
									: offer?.currency?.name?.ar
							}}
						</span>
					</p>
					<p *ngIf="offer.offerMethod == 0">
						{{ offer?.fixedAmount }}
						<span class="text-medium-gray block">
							{{ 'OFFERS.OFFERS_LIST.MIN' | translate }}
							{{ offer.fixedMinValue }}
							{{
								translate.currentLang == 'en'
									? offer?.currency?.name?.en
									: offer?.currency?.name?.ar
							}}
						</span>
					</p>
				</td>
				<!-- <td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ offer?.appointmentsCount }}
				</td> -->
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ offer?.appointmentsCount }}
					{{ 'OFFERS.OFFERS_LIST.OF' | translate }} {{ offer?.maxNoOfBookings }}
				</td>
				<td
					*ngIf="offerFilter.offerActiveTab == 0"
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<mat-slide-toggle
						class="align-top"
						[checked]="offer?.isActive"
						(change)="toggleChange.emit(offer)"
						hideIcon
					>  </mat-slide-toggle>
					<p
						*ngIf="offer?.isActive"
						class="inline-block text-font-16 text-[#00BA88] mb-0 ltr:ml-[16px] rtl:mr-[16px]"
					>
						{{ 'OFFERS.OFFERS_LIST.ACTIVE' | translate }}
					</p>
					<p
						*ngIf="!offer?.isActive"
						class="inline-block text-font-16 text-medium-gray mb-0 ltr:ml-[16px] rtl:mr-[16px]"
					>
						{{ 'OFFERS.OFFERS_LIST.INACTIVE' | translate }}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						class="inline-block max-mobile:w-[20px] w-[16px] text-end ltr:mr-[15px] rtl:ml-[15px]"
					>
						<button [routerLink]="['view-promo-code', offer.id]">
							<img
								class="inline-block"
								[src]="'assets/images/view.svg'"
								alt=""
							/>
						</button>
					</span>
					<span
						*ngIf="offerFilter.offerActiveTab == 0"
						class="inline-block max-mobile:w-[20px] w-[16px]"
					>
						<button
							(click)="openDialog(offer.id)"
							[disabled]="!offer?.canDelete"
							[ngClass]="
								!offer.canDelete ? ' opacity-[30%] cursor-default' : ''
							"
						>
							<img
								class="inline-block"
								[src]="'assets/images/delete.svg'"
								alt=""
							/>
						</button>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
